import { ApiResponse } from 'api/services/mediaPlanning/types';
import { fetchData } from 'api/services/mediaPlanning/utils';
import { Countries } from 'shared/enums';
import { CAMPAIGN } from './mediaPlanning';

export const getTargetGroups = async (
  division: string,
  countryISO: Countries,
  brand: string,
  category: string
) => {
  return fetchData<
    ApiResponse<{
      targetGroup: string[];
    }>
  >(
    `/${CAMPAIGN}/target-groups?division=${division}&countryISO=${countryISO}&brand=${brand}&category=${category}`
  );
};
